export const enHelpCenter = {
	launcher: "Help",
	title: "Help Center",
	close: "Close",
	resize: "Resize the help panel",
	openFull: "Browse the help center",
	/**
	 * EU AI Act Art. 50(1): a user must be told, clearly and at the latest at the time of the first
	 * interaction, that they are interacting with an AI system. This copy is that disclosure — keep
	 * it visible and unambiguous; do not soften it into marketing language.
	 */
	ai: {
		disclosure:
			"You're chatting with an AI assistant, not a person. It answers from the Signalist help center and can get things wrong — check the linked article, or contact support to reach a human.",
		disclosureShort: "AI assistant",
		generatedAnswer: "AI-generated",
	},
	chat: {
		placeholder: "Ask a question about Signalist…",
		send: "Send",
		empty:
			"Ask me anything about Signalist. I'll answer from the help center and link you to the right article.",
		sources: "Related articles",
		thinking: "Thinking…",
		error: "Sorry, something went wrong. Please try again.",
		busy: "The assistant is handling a lot of questions right now. Please try again in a minute.",
		dailyLimit:
			"Your workspace has used up the help assistant for today. It'll be available again tomorrow — contact support if you need an answer sooner.",
		suggestions: [
			"How do I create a lead list?",
			"How does lead scoring work?",
			"How do I connect my CRM?",
			"How are credits used?",
		],
		feedbackUp: "This was helpful",
		feedbackDown: "This wasn't helpful",
	},
	support: {
		contact: "Contact support",
		escalate: "Create a support ticket",
		title: "Contact support",
		intro:
			"Send this to our support team. We'll get your account details and this chat automatically — just add anything else that helps.",
		subjectLabel: "Subject",
		subjectPlaceholder: "What do you need help with?",
		messageLabel: "Message",
		messagePlaceholder: "Describe your question or the issue…",
		messageRequired: "Please add a short message.",
		submit: "Send to support",
		error: "We couldn't send your request. Please try again.",
		sentTitle: "Request sent",
		sentBody: "Thanks — our support team has your request and will get back to you by email.",
		done: "Done",
	},
	admin: {
		title: "Help Conversations",
		conversations: {
			title: "Help Conversations",
			empty: "No conversations yet.",
			searchPlaceholder: "Search questions & answers…",
			filterAll: "All",
			filterDown: "Rated down",
			filterUp: "Rated up",
			back: "Back to conversations",
			notFound: "Conversation not found.",
			ratedUp: "Helpful",
			ratedDown: "Not helpful",
			askedFrom: "Asked from {{page}}",
			turnsCount_one: "{{count}} message",
			turnsCount_other: "{{count}} messages",
			columns: {
				question: "First question",
				language: "Lang",
				turns: "Messages",
				feedback: "Feedback",
				company: "Company",
				date: "Started",
			},
		},
	},
};
